import React from 'react'

export default function Avatar ({ ...rest }) {
  return (
    <svg 
      width="42" 
      height="42" 
      viewBox="0 0 42 42" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" 
        fill="#283A97"
      />
      <path d="M12.5 26.6667C14.4465 24.6021 17.0892 23.3333 20 23.3333C22.9108 23.3333 25.5535 24.6021 27.5 26.6667M23.75 16.25C23.75 18.3211 22.0711 20 20 20C17.9289 20 16.25 18.3211 16.25 16.25C16.25 14.1789 17.9289 12.5 20 12.5C22.0711 12.5 23.75 14.1789 23.75 16.25Z" 
        stroke="white" 
        strokeWidth="1.66667" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path d="M35 29.25C31.8244 29.25 29.25 31.8244 29.25 35C29.25 38.1756 31.8244 40.75 35 40.75C38.1756 40.75 40.75 38.1756 40.75 35C40.75 31.8244 38.1756 29.25 35 29.25Z" 
        fill="#10B981"
      />
      <path d="M35 29.25C31.8244 29.25 29.25 31.8244 29.25 35C29.25 38.1756 31.8244 40.75 35 40.75C38.1756 40.75 40.75 38.1756 40.75 35C40.75 31.8244 38.1756 29.25 35 29.25Z" 
        stroke="white" 
        strokeWidth="1.5"
      />
    </svg>
  )
}